<!-- Rotating menu cube -->
<template>
  <div
    class="scene"
    :style="{width: size + 'vw', height: size + 'vw'}"
    @mouseenter="$store.dispatch('haltRotation')"
    @mouseleave="$store.dispatch('resumeRotation')"
  >
    <div
      class="cube"
      :style="{
                 transform: 'translateZ(-100px) ' + 'rotateX(' + $store.state.menuCube.rX + 'deg)' + ' rotateY(' + 0 + 'deg)' + ' rotateZ(' + $store.state.menuCube.rZ + 'deg)',
                 transition: $store.state.menuCube.transition,
                 width: size + 'vw',
                 height: size + 'vw'
             }"
    >
      <div
        class="cube__face cube__face--front"
        :style="{width: size + 'vw', height: size + 'vw', transform: 'rotateY(0deg) translateZ(' + size/2 + 'vw)'}"
      ></div>
      <div
        class="cube__face cube__face--back"
        :style="{width: size + 'vw', height: size + 'vw', transform: 'rotateY(90deg) translateZ(' + size/2 + 'vw)'}"
      ></div>
      <div
        class="cube__face cube__face--right"
        :style="{width: size + 'vw', height: size + 'vw', transform: 'rotateY(180deg) translateZ(' + size/2 + 'vw)'}"
      ></div>
      <div
        class="cube__face cube__face--left"
        :style="{width: size + 'vw', height: size + 'vw', transform: 'rotateY(90deg) translateZ(' + size/2 + 'vw)'}"
      ></div>
      <div
        class="cube__face cube__face--top"
        :style="{width: size + 'vw', height: size + 'vw', transform: 'rotateX(-90deg) translateZ(' + size/2 + 'vw)'}"
      ></div>
      <div
        class="cube__face cube__face--bottom"
        :style="{width: size + 'vw', height: size + 'vw', transform: 'rotateX(90deg) translateZ(' + size/2 + 'vw)'}"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RotatingCube",
  props: {
    size: {
      type: Number,
      default: 2
    }
  },
  methods: {
    // Rotates cube (increments Z coordinate)
    // Can be stopped via vuex actions
    rotate() {
      if (this.$store.state.menuCube.isRotating)
        this.$store.state.menuCube.rZ += 5;
    }
  },
  created() {
    // Start rotating
    this.$options.interval = setInterval(this.rotate, 400);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  }
};
</script>

<style scoped>
.scene {
  perspective: 400px;
}

.cube {
  position: relative;
  transform-style: preserve-3d;
}

.cube__face {
  position: absolute;
  background: hsla(0, 100%, 0%, 1);
  /* Triggers AA */
  box-shadow: 0 0 1px rgba(255, 255, 255, 0);
}
</style>